<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import { i18n } from './../libs/lang.js';
  
  import Footer from "./../components/Footer.svelte";

  function handle_start(ev) {
    navigate("/q/")
  }

  function handle_set_language(lang_id) {
    return (ev) => {
      i18n.language = lang_id
      location.reload()
    }
  }
</script>

<div>

  <div class="hero min-h-screen" style="background-image: url('/assets/pexels-adrien-olichon-3137058.jpg');">
    <!-- lang -->
    <div class="absolute top-0 right-0 text-xl underline-offset-4 z-50">
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "en"} on:click={handle_set_language("en")}>EN 🇬🇧️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "it"} on:click={handle_set_language("it")}>IT 🇮🇹️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "da"} on:click={handle_set_language("da")}>DA 🇩🇰️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "gr"} on:click={handle_set_language("gr")}>GR 🇬🇷️</span>
      <span class="p-2 cursor-pointer" class:underline={i18n.language == "fr"} on:click={handle_set_language("fr")}>FR 🇫🇷️</span>

    </div>

    <div class="hero-content text-center">
      <div class="max-w-md">
        <div class="my-8">
          <img class="mx-auto w-80" src="/assets/logo.png">
          <h1 class="text-5xl mt-8 font-bold">Business2030</h1>
          <p class="pt-6"> {$_('home.subtitle')} </p>
        </div>

        <button class="btn btn-primary" on:click={handle_start}> {$_('home.get_started')} </button>
      </div>
    </div>
  </div>
  
  <Footer/>
</div>

